import FeatureCard from "@/pages/home/home-about/feature-card/feature-card";
import type { LandingPageSection } from "@/api/admin";

interface CardsSectionProps {
  section: LandingPageSection;
}

export function CardsSection({ section }: CardsSectionProps) {
  const cards = section.cards ?? [];

  return (
    <div className="space-y-8">
      {section.heading && (
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center">
          {section.heading}
        </h2>
      )}
      {section.body && (
        <p className="text-white/60 text-base leading-relaxed text-center max-w-xl mx-auto whitespace-pre-line">
          {section.body}
        </p>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
        {cards.map((card, i) => (
          <FeatureCard
            key={card.id ?? i}
            icon={card.icon_url ?? ""}
            title={card.title}
            description={card.description}
            spotlightColor="rgba(0, 229, 255, 0.2)"
            link={card.link_url || undefined}
          />
        ))}
      </div>
    </div>
  );
}
